module.exports = __webpack_public_path__ + "static/media/foto@2x.1adcb726.png";